import React from 'react';
import { GlassCard } from '../../../_shared/GlassCard';
import { Eye, FileText, BarChart3, Trophy } from 'lucide-react';
import { TOTALS, WINDOW, STALE_NOTE, formatNum } from '../data';

const StatColumn = ({ icon: Icon, iconColor, label, displayValue, sublabel }) => {
    return (
        <div className="flex flex-col items-center text-center px-4">
            <div className={`${iconColor} p-3 rounded-xl mb-3 inline-flex`}>
                <Icon size={20} />
            </div>
            <p className="text-white/50 text-[10px] uppercase tracking-widest font-semibold mb-2">{label}</p>
            <p className="text-2xl md:text-3xl font-black text-white tracking-tight">
                {displayValue}
            </p>
            {sublabel && <p className="text-white/40 text-xs mt-1.5">{sublabel}</p>}
        </div>
    );
};

export const NetworkTotals = () => {
    return (
        <section className="py-16 px-4 pb-24">
            <div className="container mx-auto max-w-6xl">
                <p className="text-white/40 text-xs uppercase tracking-[0.2em] font-semibold text-center mb-3">Combined Totals</p>
                <h2 className="text-3xl md:text-4xl font-bold text-white mb-3 text-center">
                    All {TOTALS.accountCount} Accounts, One Window
                </h2>
                <p className="text-white/50 text-center mb-12 max-w-xl mx-auto">
                    The full network rolled up across {WINDOW.days} days.
                </p>

                <GlassCard>
                    <div className="grid grid-cols-2 md:grid-cols-4 gap-6 md:gap-2 divide-y md:divide-y-0 md:divide-x divide-white/10">
                        <StatColumn
                            icon={Eye}
                            iconColor="bg-blue-500/20 text-blue-300"
                            label="Total Views"
                            displayValue={formatNum(TOTALS.views)}
                            sublabel={`across ${TOTALS.accountCount} accounts`}
                        />
                        <StatColumn
                            icon={FileText}
                            iconColor="bg-purple-500/20 text-purple-300"
                            label="Total Posts"
                            displayValue={formatNum(TOTALS.posts)}
                            sublabel="in window"
                        />
                        <StatColumn
                            icon={BarChart3}
                            iconColor="bg-emerald-500/20 text-emerald-300"
                            label="Avg Views / Post"
                            displayValue={formatNum(TOTALS.avgViewsPerPost)}
                            sublabel="network-wide"
                        />
                        <StatColumn
                            icon={Trophy}
                            iconColor="bg-amber-500/20 text-amber-300"
                            label="Top Account"
                            displayValue={TOTALS.topAccount.handle}
                            sublabel={`${TOTALS.topAccount.platform} · ${formatNum(TOTALS.topAccount.views)} views`}
                        />
                    </div>
                </GlassCard>

                <p className="text-white/30 text-xs text-center mt-6 max-w-2xl mx-auto">{STALE_NOTE}</p>
            </div>
        </section>
    );
};
